import * as API from '@siloreal:shared:api';

const MASSIVE_SILOBAG_TAG_UPDATE_ENDPOINT = '/tags/silobag_tags/massive';

export type MassiveSilobagTagOperation = {
  silobagIds: readonly string[];
  tagIds: readonly number[];
};

export type MassiveSilobagTagUpdateServiceContract = {
  removeTags?: MassiveSilobagTagOperation;
  addTags?: MassiveSilobagTagOperation;
  signal?: AbortSignal;
};

export type MassiveSilobagTagUpdateRequestBody = {
  remove_tags?: {
    silobag_ids: string[];
    tag_ids: number[];
  };
  add_tags?: {
    silobag_ids: string[];
    tag_ids: number[];
  };
};

export type MassiveSilobagTagUpdateResponse = {
  error: boolean;
  message: string;
  response: boolean;
};

function serializeOperation(
  operation: MassiveSilobagTagOperation
): NonNullable<MassiveSilobagTagUpdateRequestBody['add_tags']> {
  return {
    silobag_ids: [...operation.silobagIds],
    tag_ids: [...operation.tagIds],
  };
}

export async function updateSilobagTagsMassivelyService(
  contract: MassiveSilobagTagUpdateServiceContract
): Promise<MassiveSilobagTagUpdateResponse> {
  const body: MassiveSilobagTagUpdateRequestBody = {
    ...(contract.removeTags ? { remove_tags: serializeOperation(contract.removeTags) } : {}),
    ...(contract.addTags ? { add_tags: serializeOperation(contract.addTags) } : {}),
  };

  const { data } = await API.http.fetch.post<MassiveSilobagTagUpdateResponse>(
    MASSIVE_SILOBAG_TAG_UPDATE_ENDPOINT,
    {
      body,
      signal: contract.signal,
    }
  );

  return data;
}
